import {
	api_methods
} from '@/service/loadData'

import {
	SET_NOTICES,
	SET_WAREHOUSE,
	SET_PRODUCTSTOCK,
	SET_PRODUCT,
	SET_PRODUCTLIMT,
	SET_PROMTE,
	INIT_NEWPROMOCODE,
	INIT_BUYCART,
	INIT_REPLACE_BUYCART,
	SET_PRODUCTMENUTREE,
} from './mutation-types.js'
import util from '@/config/util'
function OmsCartList(model) {
	let modelArr = new Array;
	model.forEach(item => {
		modelArr.push({
			'skuID': item.sku,
			'qty': item.num
		})
	})

	return modelArr;
}

const timeComparison = (str, str1,strnow) => {
    var valid_from = (!str) ? null : util.formatDate.dateFromStr(str);
	var valid_to = (!str1) ? null : util.formatDate.dateFromStr(str1);
	var now=util.formatDate.dateFromStr(strnow);
    return (valid_from <= now || !valid_from) &&
        (valid_to >= now || !valid_to)
}

const getCheckBalanceError=(type)=>{
	if(type=='AB'){
		return '账户余额不足'
	}
	if(type=='PT'){
		return '账户点数不足'
	}
	if(type=='AR'){
		return '账户积分不足'
	}
}


let systemError = {msg:'系统异常，请稍后重试',code:-1};
export default {
	async initNoticeAction({ commit, state, getters }) {
		var newmodules=[];
		let uData = await api_methods.getNoticeInfo(getters.getAccessToken, getters.getUserId);
		if (uData?.data && uData?.response?.code == '1') {
			newmodules=uData.data.value.list || []
			commit(SET_NOTICES, uData.data);
		}else if(uData?.response?.code == '0'){
			newmodules=uData.value.list || []
		}
		return newmodules.filter(u =>timeComparison(u.valid_from, u.valid_to,getters.nowTime));
	},
	async initWarehouseAction({ commit, state, getters }) {
		let uData = await api_methods.getWarehouseInfo(getters.getAccessToken, getters.getUserId);
		if (uData?.data && uData?.response?.code == '1') {
			commit(SET_WAREHOUSE, uData.data);
		} else if (uData.response.code == '-1') {
			commit(SET_WAREHOUSE, null);
		}
	},
	//初始化产品库存列表
	async initProductStock({ commit, state, getters }, default_store_id) {
		var s = default_store_id
		let uData = await api_methods.getProductStock(getters.getAccessToken, getters.getUserId, s);
		if (uData?.data && uData?.response?.code == '1') {
			commit(SET_PRODUCTSTOCK, uData.data);
		} else if (uData.response.code == '-1') {
			commit(SET_PRODUCTSTOCK, null);
		}
		
	},
	//初始化产品列表
	async initProductAction({ commit, state, getters }) {
		let uData
		console.log('getters.useCDN',getters.useCDN)
		if(getters.useCDN){
			uData= await api_methods.getCDNProductInfo(getters.getAccessToken, getters.getUserId, {fc:getters.getCustomerType});
		}
		else{
			uData=await api_methods.getProductInfo(getters.getAccessToken, getters.getUserId, getters.getVipNo);
		}
		if (uData?.data && uData?.response?.code == '1') {
			commit(SET_PRODUCT, uData.data);
		} else if (uData.response.code == '-1') {
			commit(SET_PRODUCT, null);
		}
	},
	async getProductDetailAction({ getters }, sku) {
		let uData = await api_methods.getProductDetail(getters.getAccessToken, getters.getUserId, sku);
		if (uData?.data && uData?.response?.code == '1') {
			return uData.data.value;
		}
		return null;
	},
	async getProductDetail1Action({ getters }, { sku, it }) {
		var uData = await api_methods.getProductDetail1(getters.getAccessToken, getters.getUserId, sku, it);
		if (uData?.data && uData?.response?.code == '1') {
			return uData.data.value;
		}
		return null
	},
	async saveCartAction({ getters, state }, { minCart, type }) {
		//开启配置
		if(!type&&getters.bogo_switch){
			return {"key":null,"response":{"code":"1","errorCode":"0000","message":null,"time":"2019-05-24 15:17:53"},"data":{"version":{"version":11,"last_up_time":"2019-05-24T15:17:53.0724551+08:00","expired":200},"value":{"code":"1","message":"插入成功"}},"request":null}
	    }
		let uData = await api_methods.saveCart(getters.getAccessToken, getters.getUserId, minCart, 0, new Date());
		return uData
	},		
	async initProductLimtAction({ commit, state, getters }) {
		var vipno = getters.getVipNo == 'newRegister' ? null : getters.getVipNo;
		if (state.forCustomer) {
			vipno = state.forCustomer.vipno
		}
		let uData = await api_methods.getProductLimt(getters.getAccessToken, getters.getUserId, vipno);

		if (uData && uData.data && uData.response.code == '1') {
			commit(SET_PRODUCTLIMT, uData.data);
		} else if (uData.response.code == '-1') {
			commit(SET_PRODUCTLIMT, null);
		}
	},
	async getCustomerNumStatisticsAction({ getters }, VipNo) {
		var uData = await api_methods.getCustomerNumStatistics(getters.getAccessToken, getters.getUserId, VipNo);
		if (uData && uData.data && uData.response.code == '1') {
			if (uData.data.value && uData.data.value) {
				return uData.data.value;
			}
		}
		return null;
	},
	async postAddAddressAction({commit,state,getters},params) {
		let uData = await api_methods.postAddAddress(getters.getAccessToken, getters.getUserId, params);
		if(uData&&uData.data&&uData.response.code == '1') {
			return uData.data.value;
		}
	},
	async delAddressAction({commit,state,getters},id) {
		let uData = await api_methods.delAddress(getters.getAccessToken, getters.getUserId, getters.getCustomerId,id);
		if(uData&&uData.data&&uData.response.code == '1') {
			return uData.data.value;
		}
	},
	async getOrderStatusAction({getters},orderNo){
		let uData = await api_methods.getOrderStatus(getters.getAccessToken,getters.getUserId,orderNo);
		if (uData && uData.data && uData.response.code == '1'){
			if (uData.response.code == 1) {
				return uData.data.value;
			}
		}
		return null
	},
	// 支付方法
	async unionPayAction({getters},params){
		let uData = await api_methods.unionPay(getters.getAccessToken,getters.getUserId,params);
		if (uData && uData.data && uData.response.code == '1'){
			return uData.data.value;
		}
	},
	async getProductRelatedAction({getters},sku){
		let uData = await api_methods.getProductRelated(getters.getAccessToken,getters.getUserId,sku);
		if (uData && uData.data && uData.response.code == '1'){
			if (uData.response.code == 1) {
				return uData.data.value;
			}
		}
		return null
	},
	//校验 IDCard，图片验证码，email，phone
	async WxcheckCodeAction({commit,state,getters},params){
		let uData = await api_methods.WxcheckCode(getters.getAccessToken,getters.getUserId,params.type,params.code,params.uc);
		if (uData && uData.data && uData.response.code == '1'){
			if (uData.response.code == 1) {
				return uData.data.value.v;
			}
		}
		return -1;
	},
	async getWXOrdersAction({getters},params) {
		let uData = await api_methods.getWXOrderList(getters.getAccessToken,getters.getUserId,params);
		if (uData && uData.response.code == '1') {
			return uData.data.value;
		}
		return systemError;
	},
	async getOrdersAction({getters},params) {
		let uData = await api_methods.getOrders(getters.getOpenId,getters.getVipNo,params);
		if (uData && uData.response.code == '1') {
			return uData.data.value;
		}
		return systemError;
	},
	async getWXOrderDetailAction({getters},orderno) {
		let uData = await api_methods.getWXOrderDetail(getters.getAccessToken,getters.getUserId,getters.getUserId,orderno);
		if (uData && uData.response.code == '1') {
			return uData.data.value;
		}
		return systemError;
	},
	async getOMSOrderDetailAction({getters},orderno) {
		let uData = await api_methods.getOMSOrderDetail(getters.getAccessToken,getters.getVipNo,orderno);
		if (uData && uData.response.code == '1') {
			return uData.data.value;
		}
		return systemError;
	},
	async getOrderChannelAction({getters},{orderid,from,vipno}) {
		let uData  = await api_methods.getOrderChannel(getters.getOpenId,getters.getVipNo,orderid);
		if (uData && uData.response.code == '1') {
			return uData.data.value.Value;
		}
		return systemError;
	},
	
	async cancelHistoryOrderAction({getters},orderid) {
		let uData = await api_methods.cancelHistoryOrder(getters.getAccessToken,getters.getUserId,orderid);
		if (uData && uData.response.code == 1) {
			return uData.data.value
		}
		return systemError;
	},
	async getOrderEncryptionAction({getters},order_no) {
		var uData  = await api_methods.getOrderEncryption(getters.getAccessToken, getters.getUserId,order_no);
		if(uData && uData.data && uData.response.code == '1') {
			if(uData.data.value&&uData.data.value){
				return uData.data.value;
			}
		}
		return null;
	},
	async getOrderInvoiceAction({getters},orderno){
		let uData = await api_methods.getOrderInvoice(getters.getOpenId,getters.getVipNo,orderno);
		if (uData && uData.response.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getInvoiceInfoAction({getters}){
		let uData = await api_methods.getInvoiceInfo(getters.getOpenId,getters.getVipNo);
		if (uData && uData.response.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async postOrderInoviceAction({getters},{OrderNo,OriginalID,OrderDate,InvoiceAmount,invoice}){
		let uData = await api_methods.postOrderInovice(getters.getOpenId,getters.getVipNo,OrderNo,OriginalID,OrderDate,InvoiceAmount,invoice);
		if (uData && uData.response.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async postInvoiceInfoAction({getters},invoice){
		let uData = await api_methods.postInvoiceInfo(getters.getOpenId,getters.getVipNo,invoice);
		if (uData && uData.response.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async postDeleteInvoiceInfoAction({getters},ID){
		let uData = await api_methods.postDeleteInvoiceInfo(getters.getOpenId,getters.getVipNo,ID);
		if (uData && uData.response.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async GetInvoiceDownAction({getters},orderno){
		let uData = await api_methods.GetInvoiceDown(getters.getOpenId,getters.getVipNo,orderno);
		if (uData && uData.response.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async GetInvoiceCancelAction({getters},RecordId){
		let uData = await api_methods.GetInvoiceCancel(getters.getOpenId,getters.getVipNo,RecordId);
		if (uData && uData.response.code == 1) {
			return uData.data.value.Value;
		}
		return systemError;
	},
	async postInvoiceEmailAction({getters},{RecordId,EmailAddress}){
		let uData = await api_methods.postInvoiceEmail(getters.getOpenId,getters.getVipNo,RecordId,EmailAddress);
		if (uData && uData.response.code == 1) {
			return uData.data.value.Value;
		}
		return systemError;
	},
	async getInvoiceEmailAction({getters}){
		let uData = await api_methods.getInvoiceEmail(getters.getOpenId,getters.getVipNo);
		if (uData && uData.response.code == 1) {
			return uData.data.value.Value;
		}
		return systemError;
	},
	async initPromoteAction({commit,state,getters},cache) {
		if(cache&&getters.bogo_switch){
			commit(SET_PROMTE, null);
			return 1
		}
		var vipno=getters.getVipNo;
		if(vipno==null){
			commit(SET_PROMTE, null);
			return 1
		}
		if(state.forCustomer){
			vipno=state.forCustomer.vipno
		}
		if(vipno=='newRegister'){
			vipno=null;
		}
		let uData = await api_methods.getPromote(getters.getAccessToken, getters.getUserId,vipno);
		if(uData && uData.data && uData.response.code == '1') {
			let value = uData.data.value
			value = value.filter(item=>!item.other_rules || !(item.other_rules.indexOf('notrt') != -1 && getters.getCustomerType == 'RT'))
			value.filter(item=>item.other_rules && (item.other_rules.indexOf('mutex') != -1 ||item.other_rules.indexOf('combine') != -1) ).map(item=>{
				let [other_rules,promote_mode,sku] = item.other_rules.split('|')
				item.promote_mode = promote_mode
				item.other_rules = other_rules
				item.detail.map(item1=>{
					item1.promote_mode = promote_mode
					item1.type = sku == item1.sku ? 'default':'optional'
					item1.detail_description = item.detail_description
					return item1
				});
				if (item.promote_mode == 'mutex') {
					let optionals = [...item.detail]
					let defaultIndex = item.detail.findIndex(item=>item.sku == sku)
					let detail = Object.assign({},item.detail[defaultIndex])
					detail.optionals = optionals
					item.detail = [detail]
				} else {
					// 组合促销，设置虚拟产品，计算库存
					let optionals = [...item.detail]
					optionals.map(item1=>{
						item1.store_id = [...item.store_id.filter(item2=>item2.sku == item1.sku)]
						item1.control = 2
						return item1
					})
					let detail = Object.assign({},item.detail[0])
					// 计算组合库存
					let store_id = item.store_id.map(store=>{
						let {control,header_id,sku,stock,store_id} = store
						stock = item.store_id.filter(item1=>item1.store_id == store_id).reduce((prev,cur)=>{
							return prev + (cur.stock > 0 ? cur.stock:0)
						},0)
						if (stock > 0) control = 2
						return {control,header_id,sku,stock,store_id}
					}) 

					// store_id.stock = optionals.reduce((prev,cur)=>{
					// 	return prev + cur.store_id.stock
					// },0)
					detail.control = store_id[0].stock > 0 ? 2:1
					// 计算总共已享受赠品数量
					detail.cust_current_giftskunum = optionals.reduce((prev,cur)=>{
						return prev + cur.cust_current_giftskunum
					},0)
					store_id.control = store_id.stock > 0 ? 2:1
					item.store_id = store_id
					detail.optionals = optionals
					item.detail = [detail]
				}
				
				return item
			})
			uData.data.value = value
			// 判断职级礼促销
			uData.data.value = configLevelGiftPromotion(uData.data.value)
			commit(SET_PROMTE, uData.data);
			return 1
		} else if(uData.response.code == '-1') {
			commit(SET_PROMTE, null);
		}
	},
	async checkBirthdaySuitAction({getters},uid){
		var uData  = await api_methods.checkBirthdaySuit(getters.getAccessToken, getters.getUserId,uid);
		if(uData && uData.data && uData.response.code == '1') {
			if(uData.data.value&&uData.data.value){
				return uData.data.value;
			}
		}
		return null;
	},
	async changeOrderAddressAction({getters},address){
		var uData  = await api_methods.changeOrderAddress(getters.getAccessToken, getters.getUserId,address);
		if(uData && uData.data && uData.response.code == '1') {
			if(uData.data.value&&uData.data.value){
				return uData.data.value;
			}
		}
		return null;
	},
	async checkQuestionnaireAction({getters},Id){
		let uData = await api_methods.checkQuestionnaire(getters.getOpenId,getters.getVipNo);
		if (uData && uData.response.code == 1) {
			return uData.data.value.Value
		}
		return systemError;
	},
	async initCartAction({commit,state,getters},status) {

		if(getters.bogo_switch) return
		var vipno=getters.getVipNo;
		if(state.forCustomer){
			vipno=state.forCustomer.vipno
		}
		if(getters.getUserId){
			commit('SAVE_TRACE','cartInfo');
			let uData = await api_methods.getCartInfo(getters.getAccessToken, getters.getUserId,vipno);	
			if(uData && uData.data && uData.response.code == '1') {
				commit(INIT_NEWPROMOCODE,{cart:uData.data,status})
				if(status){
					commit(INIT_BUYCART, uData.data);
				}
				else{
					commit(INIT_REPLACE_BUYCART,uData.data)
				}

			} else if(uData.response.code == '-1') {
				commit(INIT_BUYCART, null);
			}
		}
		
	},
	async postSpecInfoAction({commit,state,getters},params){
		var vipno=getters.getVipNo;
		if(state.forCustomer){
			vipno=state.forCustomer.vipno
		}
		params.PcNo=vipno||''
		var uData  = await api_methods.postSpecInfo(getters.getAccessToken, getters.getUserId,params);
		if(uData && uData.data && uData.response.code == '1') {
			if(uData.data&&uData.data.value!=null){
				return uData.data.value;
			}
		}
		return null;
	},
	async getSpecInfoAction({commit,state,getters},{res,pcode,category}){

		var customerId=getters.getUserId;
		if(!customerId){
			customerId=0
		}
		var uData  = await api_methods.getSpecInfo(getters.getAccessToken, getters.getUserId,res,pcode,category,customerId);
		if(uData && uData.data && uData.response.code == '1') {
			if(uData.data&&uData.data.value!=null){
				return uData.data.value;
			}
		}
		return null;
	},

	async updateCartAction({commit,state,getters},{sku,num,code,remark}){
		if(getters.bogo_switch) return
		 var customerId=getters.getUserId;
		 if(customerId){
			await api_methods.updateCart(getters.getAccessToken, getters.getUserId,sku,num,customerId,code,remark);
		 }
		 
	},
	async getAccountBalanceAction({commit,state,getters}){
		var uData= await api_methods.getAccountBalance(getters.getAccessToken, getters.getUserId);
		if (uData?.response?.code == 1) {
			var res=uData.data.value;
			if(res[0]){
				return res
			}
		}
		return []
	},
	async checkAccountBalanceAction({commit,state,getters},{ ar, pt,ab,step,isBegin}){
		if ((step == 1 || step == 2) && getters.bogo_switch) return
		
		var arry=[]
		if(ar>0){
			arry.push({"type":"AR","val":ar})
		}
		if(pt>0){
			arry.push({"type":"PT","val":pt})
		}
		if(ab>0){
			arry.push({"type":"AB","val":ab})
		}
		if(!arry[0]) return null

		var params={
			isBegin,
			arry
		};
		var uData= await api_methods.checkAccountBalance(getters.getAccessToken, getters.getUserId,params);
		if (uData?.response?.code == 1) {
			var res=uData.data.value;
			var msg=null
			if(res.length==arry.length){
				res.forEach((item,index)=>{
					if(!item.pass){
						if(!msg) msg='';

						msg+=getCheckBalanceError(item.type)+','
					}
				})
				if(msg){
					return msg.substring(0,msg.length-1);
				}
				return null
			}
		}
		return '验证失败'

	},
	//验证产品积分
	async CheckPoint({ getters, state }, { point, step }) {
		if (point > 0) {
			if ((step == 1 || step == 2) && getters.bogo_switch) return

			var vipno = getters.getVipNo;
			var ret = await api_methods.getUserAccountPoint(getters.getAccessToken, getters.getUserId, vipno, point);
			if (ret && ret.response && ret.response.code == '1') {
				if (!ret.data.value.pass) {
					return '回馈点数不足'
				}
			}
			else {
				return '点数验证异常'
			}
		}

	},
	async CheckAR({ getters, state }, { ar, step }) {
		var result = parseFloat(ar);
		if (isNaN(result) || result <= 0) {
			return
		}

		if ((step == 1 || step == 2) && getters.bogo_switch) return

		var vipno =  getters.getVipNo;
		let arResult = await api_methods.GetUserAccountAR(getters.getAccessToken, getters.getUserId, vipno, result);
		if (arResult && arResult.response && arResult.response.code == '1' && arResult.data.value.pass == true) {
			console.log(arResult)
			return
		}

		return '产品积分不足';
	},
	async CheckCart({ getters }, { ll, store_id,orderNo, step }) {
		if ((step == 1 || step == 2) && getters.bogo_switch) return

		var omsCar = OmsCartList(ll);
		var res = await api_methods.CheckInventory(getters.getAccessToken, getters.getUserId, store_id, orderNo,omsCar);
		if (res && res.data && res.response.code == '1') {
			if (res.data.value == 1) {
				return
			}
			else if (res.data.value == -1) {
				return '库存检索异常'
			}
			var data = res.data.value;//[{skuID:'60202609'},{skuID:'60202253'}]
			var model = data//res.data.value;
			if (model.length > 0) {
				//找出sku 对应名字
				var name = '';
				ll.forEach(item => {
					model.forEach(item1 => {
						if (item.sku == item1) {
							name += `${item.sku} ${item.name}/`
						}
					})
				})
				name = name.substring(0, name.length - 1);
				return `${name}，库存不足，请您稍后再试`;
			}
		}
		else {
			return '库存检索异常'
		}
	},
	async mergeOrdersAction({ getters, state },{Address,OCNo,OrderList}){
		let uData
		if (OCNo) {
			uData = await api_methods.mergePaidOrders(getters.getAccessToken, getters.getUserId, getters.getVipNo,Address,OCNo);
		} else {
			uData = await api_methods.mergeOrders(getters.getAccessToken, getters.getUserId, getters.getVipNo,Address,OrderList);
		}
		if (uData && uData.response.code == 1) {
			return uData.data.value.data
		}
		return systemError;
	},
	async getMergeOrdersAction({ getters, state },OcNo){
		let uData
		if (OcNo) {
			uData = await api_methods.getPaidMergeOrders(getters.getAccessToken, getters.getUserId, getters.getVipNo,OcNo);
		} else {
			uData = await api_methods.getMergeOrders(getters.getAccessToken, getters.getUserId, getters.getVipNo,OcNo);	
		}
		
		if (uData && uData.response.code == 1) {
			return uData.data.value.data
		}
		return systemError;
	},
	async getCustomerRewardsAction({getters, state},{orderNo,vipNo}){
		var uData= await api_methods.getCustomerRewards(getters.getAccessToken, getters.getUserId,orderNo,vipNo);		
		if (uData && uData.response.code == 1) {
			return uData.data.value
		}
		return null;
	},
	async lrptSaveCustomerDateAction({commit,state,getters},info) {
		let uData = await api_methods.lrptSaveCustomerDate(info.UserToken||getters.getAccessToken, getters.getUserId,info);	
		if(uData && uData.data && uData.response.code == '1') {
			return uData.data.value;
		}
		else if(uData.response.code == '-1'){
			return uData.response.message;
		}
		return null;
	},
	async getCustomerCouponsAction({getters},vipNo) {
		let uData = await api_methods.getCustomerCoupons(getters.getAccessToken, getters.getUserId,getters.getOrderVipNo);
		if (uData && uData.response.code == '1') {
			if (uData.data.value) {
				let jsonstr = JSON.stringify(uData.data.value).replace(/"([\w\d]+)":/g,a=>{
					return a.replace(a[1],a[1].toLowerCase())
				})
				let data = JSON.parse(jsonstr)
				data.couponList.forEach(item=>{
					item.detailList = item.detailList.sort((left,right)=>{
						let sortValue = Date.fromStr(left.validTo) - Date.fromStr(right.validTo)
						return sortValue
					})
				})
				return data;
			}
			return null;
		}
		return systemError;
	},
	async getRightTopNumAction ({commit,state,getters}) {
		let uData= await api_methods.getRightTopNum(getters.getAccessToken, getters.getUserId);
		let uData1= await api_methods.getMergePayOrderCount(getters.getAccessToken, getters.getUserId);
		let UnManualCombineOrder = uData1?.data?.value?.data?.UnManualCombineOrder || 0
		if(uData && uData.data && uData.response.code == '1') {
			return {...uData.data.value,UnManualCombineOrder}
		}
		return null
	},
	async getProductMenuTreeAction({getters,commit}) {
		let uData = await api_methods.getProductMenuTree(getters.getAccessToken, getters.getUserId);
		if (uData && uData.response.code == '1') {
			commit(SET_PRODUCTMENUTREE,uData.data.value)
			return
		}
		commit(SET_PRODUCTMENUTREE,[])
	},
	async getVideoServiceAction({getters},{Code, sign}) {
		let uData = await api_methods.getVideoService(getters.getAccessToken, getters.getUserId, Code, sign);
		if(uData&&uData.data&&uData.response.code == '1') {
			return uData.data.value;
		}
		return null
	},
	async getMergePayOrderAction({getters},no){
		let uData = await api_methods.getMergePayOrder(getters.getAccessToken, getters.getUserId,no);
		if(uData&&uData.data&&uData.response.code == '1') {
			return uData.data.value.data;
		}
		return null
	}
}
const configLevelGiftPromotion = (value) => {
	let levelGiftPromotions = value.filter(item=>item.other_rules?.toLowerCase() == 'levelgift')
	if (levelGiftPromotions.length) {
		// 新的职级礼促销
		let newLevelGiftPromotion = JSON.parse(JSON.stringify(levelGiftPromotions[0]))
		for (let i = 1; i < levelGiftPromotions.length; i ++) {
			newLevelGiftPromotion.detail.push(...levelGiftPromotions[i].detail)
			newLevelGiftPromotion.store_id.push(...levelGiftPromotions[i].store_id)
		}
		newLevelGiftPromotion.description = newLevelGiftPromotion.description.replace(/\{([^\{.]+)\}(.*)\{([^\{.]+)\}/,(match,p1,p2,p3)=>{
			if (levelGiftPromotions.length > 1) {
				p1 = '',p3 = ''
				let manager = levelGiftPromotions.filter(item=>item.name.indexOf('销售经理') != -1)
				if (manager.length) {
					p1 += manager.length > 1 ? `达成销售经理${manager.length}次、` : manager[0].name + '、'
					p3 += `销售经理达成礼物及`
				}
				let director = levelGiftPromotions.filter(item=>item.name.indexOf('销售总监') != -1)
				if (director.length) {
					p1 += director.length > 1 ? `达成销售总监${director.length}次、`:director[0].name + '、'
					p3 += `销售总监达成礼物及`
				}
				p1 = p1.substr(0,p1.length - 1)
				p3 = p3.substr(0,p3.length - 1)
			}
			return p1 + p2 + p3
		})
		value = value.filter(item=>item.other_rules?.toLowerCase() != 'levelgift')
		value.push(newLevelGiftPromotion)
	}
	return value
}
